@if (isArray()) {
  <div
    class="border-default bg-surface flex max-h-40 w-full flex-wrap items-center gap-2 overflow-y-auto rounded-lg border p-2">
    @for (date of dates(); track date) {
      <div
        class="border-default bg-surface inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5">
        <p class="text-text-primary text-xs font-medium">{{ date }}</p>
        <button
          type="button"
          (click)="removeDate(date)"
          class="text-text-tertiary hover:text-text-primary ml-1 inline-flex h-4 w-4 items-center justify-center rounded-full transition-colors">
          <i [class]="ICONS.x" class="text-xs"></i>
        </button>
      </div>
    }
    <input
      type="date"
      class="text-text-primary min-w-[150px] flex-1 border-0 bg-transparent text-sm outline-none focus:ring-0"
      [id]="id()"
      [min]="(min() | date: 'yyyy-MM-dd') ?? null"
      [max]="(max() | date: 'yyyy-MM-dd') ?? null"
      (change)="addDate($event)"
      (blur)="onTouched()" />
  </div>
} @else {
  <input
    [type]="needTime() ? 'datetime-local' : 'date'"
    class="border-default bg-surface text-text-primary placeholder-text-tertiary focus:border-accent-focus focus:ring-accent-focus block w-full rounded-lg border p-2.5 text-sm"
    [value]="(value() | date: (needTime() ? 'yyyy-MM-ddTHH:mm' : 'yyyy-MM-dd')) ?? null"
    [id]="id()"
    [min]="(min() | date: (needTime() ? 'yyyy-MM-ddTHH:mm' : 'yyyy-MM-dd')) ?? null"
    [max]="(max() | date: (needTime() ? 'yyyy-MM-ddTHH:mm' : 'yyyy-MM-dd')) ?? null"
    [required]="required()"
    (input)="onInput($event)"
    (blur)="onTouched()" />
}
